import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AdminService } from '../../../core/services/admin.service';
import { AuthService } from '../../../core/services/auth.service';
import { AlertService } from '../../../shared/alert/alert.service';
import { GlobalConstants } from '../../../core/constants/global-constants';
import { AuthStatus } from '../../../core/auth-status.enum';

@Component({
  selector: 'app-bypass-login',
  templateUrl: './bypass-login.component.html',
  styleUrls: ['./bypass-login.component.scss']
})
export class BypassLoginComponent implements OnInit {
  form: UntypedFormGroup;
  isProcessing = false;
  bypassEnabled = false;
  loading = true;

  constructor(
    private adminService: AdminService,
    private authService: AuthService,
    private alertService: AlertService,
    private router: Router
  ) {}

  ngOnInit() {
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      password: new UntypedFormControl('', Validators.required)
    });

    this.adminService.isBypassAuthEnabled().subscribe({
      next: (response) => {
        this.bypassEnabled = response.enabled;
        this.loading = false;
      },
      error: () => {
        this.bypassEnabled = false;
        this.loading = false;
      }
    });
  }

  onSubmit() {
    if (!this.form.valid) return;

    this.isProcessing = true;

    this.adminService.bypassLogin(
      this.form.get('email').value,
      this.form.get('password').value
    ).subscribe({
      next: (response) => {
        sessionStorage.setItem(GlobalConstants.bypassTokenStorageKey, response.token);

        // Decode JWT to extract roles and claims
        const payload = this.decodeJwtPayload(response.token);
        if (payload) {
          const pgRoles = payload['pgRoles'] || [];
          const roles = Array.isArray(pgRoles) ? pgRoles : [pgRoles];

          // Store roles and claims in the same format as getRolesFromApi
          localStorage.setItem(GlobalConstants.userRolesStorageKey, JSON.stringify(roles));
          localStorage.setItem(GlobalConstants.userClaimsStorageKey, JSON.stringify(roles));
        }

        this.authService.authStatus.next(AuthStatus.Authenticated);
        this.authService.rolesLoaded.next(true);

        this.alertService.showSuccessAlert('Login successful.');
        this.router.navigate(['/trial']);
      },
      error: (err) => {
        this.isProcessing = false;
        this.alertService.showWarningAlert(err.error?.title || 'Login failed.');
      }
    });
  }

  private decodeJwtPayload(token: string): any {
    try {
      const payload = token.split('.')[1];
      const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(decoded);
    } catch {
      return null;
    }
  }
}
